module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kd-Lc.c8a4693c.png";